/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Reasoning_Block_DescriptionInputs */

const es_components_reasoning_block_description = /** @type {(inputs: Components_Reasoning_Block_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizando con pensamiento extendido...`)
};

const en_components_reasoning_block_description = /** @type {(inputs: Components_Reasoning_Block_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing with extended thinking...`)
};

/**
* | output |
* | --- |
* | "Analyzing with extended thinking..." |
*
* @param {Components_Reasoning_Block_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_reasoning_block_description = /** @type {((inputs?: Components_Reasoning_Block_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Reasoning_Block_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_reasoning_block_description(inputs)
	return en_components_reasoning_block_description(inputs)
});
export { components_reasoning_block_description as "components.reasoning_block.description" }